<template>
  <svg
    class="icon-base"
    fill="currentColor"
    viewBox="0 0 18 12"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.9969 1C16.8031 1 16.6063 1.05625 16.4281 1.17812L13 3.31563V1.49375C13 0.66875 12.275 0 11.3813 0H1.61875C0.725 0 0 0.66875 0 1.49375V10.5063C0 11.3313 0.725 12 1.61875 12H11.3813C12.275 12 13 11.3313 13 10.5063V8.68437L16.4281 10.8188C16.6063 10.9438 16.8063 10.9969 16.9969 10.9969C17.5156 10.9969 18 10.5906 18 10.0125V1.98438C18 1.40625 17.5156 1 16.9969 1ZM11.5 10.4656C11.4812 10.4781 11.4438 10.5 11.3813 10.5H1.61875C1.55625 10.5 1.51875 10.4812 1.5 10.4656V1.53437C1.51875 1.52187 1.55625 1.5 1.61875 1.5H11.3813C11.4438 1.5 11.4812 1.51875 11.5 1.53437V10.4656ZM16.5 9.1L13 6.91875V5.08437L16.5 2.90312V9.1ZM9 5.25H7.25V3.5C7.25 3.225 7.025 3 6.75 3H6.25C5.975 3 5.75 3.225 5.75 3.5V5.25H4C3.725 5.25 3.5 5.475 3.5 5.75V6.25C3.5 6.525 3.725 6.75 4 6.75H5.75V8.5C5.75 8.775 5.975 9 6.25 9H6.75C7.025 9 7.25 8.775 7.25 8.5V6.75H9C9.275 6.75 9.5 6.525 9.5 6.25V5.75C9.5 5.475 9.275 5.25 9 5.25Z"
    />
  </svg>
</template>
